<div (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDropSuccess($event)" [class]="isDraggingOver ? 'file-drop active' : 'file-drop'">
    <div (click)="fileInput.click()" class="icon">
        <mat-icon color="primary">expand_more</mat-icon>
    </div>
    <div>Drag or drop your file here</div>
    <div>OR</div>
    <div>
        <input #fileInput style="display: none" (change)="onChange($event)" type="file" [accept]="acceptedFileTypes"/>
        <div (click)="fileInput.click()" class="fake-button">Browse Files</div>
    </div>
    <div>{{acceptedFileTypes}} only</div>
    <div>Max size {{fileSize}}MB</div>
</div>
